import {
  ConsolidatedInspectionActivity,
  ConsolidatedInspectionActivityModel,
  DataEntityLayoutModel,
  SingleColumnFormLayoutModel
} from 'src/app/models/activities';

export function applyNoScheduleOnlyCompleteStepFilter(
  activity: ConsolidatedInspectionActivity
) {
  const indices = (activity?.model as ConsolidatedInspectionActivityModel)
    ?.noScheduleOnlyColumnEntityIndices;

  if (!Array.isArray(indices) || indices.length === 0) {
    return;
  }

  const requestLen =
    (activity?.model?.requestStepActivity?.model
      ?.formLayoutModel as SingleColumnFormLayoutModel)?.columnEntities
      ?.length ?? 0;

  const scheduleLen =
    (activity?.model?.scheduleStepActivity?.model
      ?.formLayoutModel as SingleColumnFormLayoutModel)?.columnEntities
      ?.length ?? 0;

  const completeLayout = activity?.model?.completeStepActivity?.model
    ?.formLayoutModel as SingleColumnFormLayoutModel;

  const completeEntries = completeLayout?.columnEntities;

  if (!completeEntries || completeEntries.length === 0) {
    return;
  }

  const offset = requestLen + scheduleLen;
  const localFlagged = new Set<number>();

  for (const mergedIdx of indices) {
    const localIdx = mergedIdx - offset;

    if (localIdx >= 0 && localIdx < completeEntries.length) {
      localFlagged.add(localIdx);
    }
  }

  if (localFlagged.size === 0) {
    return;
  }

  completeLayout.columnEntities = completeEntries.filter(
    (_: DataEntityLayoutModel, i: number) => !localFlagged.has(i)
  );
}